import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { HouseholdGuardianInvitesService } from '@se-po/shared-data-access-services'
import { environment } from '@se-po/shared-environments'

@Component({
  selector: 'app-guardian-invite',
  template: '',
  styles: [],
  standalone: false,
})
export class GuardianInviteComponent implements OnInit {

  constructor(
    private inviteService: HouseholdGuardianInvitesService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id')
    const activationCode = this.route.snapshot.queryParamMap.get('activation_code')

    if (id && activationCode) {
      this.inviteService.acceptInvite(id, activationCode).subscribe({
        next: (response) => this.redirect(`${environment.mySE}/household?id=${response.persona_id}`),
        error: (error) => {
          const errorMessage = this.extractErrorMessage(error)
          this.redirect(`${environment.mySE}/household?error=${encodeURIComponent(errorMessage)}`)
        }
      })
    } else {
      const errorMessage = 'Missing Params'
      this.redirect(`${environment.mySE}/household?error=${encodeURIComponent(errorMessage)}`)
    }
  }

  redirect(url: string): void {
    window.location.href = url
  }

  private extractErrorMessage(error: any): string {
    return (error?.error?.error?.messages || [])[0]   || 'Unknown error occurred.'
  }
}
